var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 12.0005C10.9 12.0005 9.95833 11.6088 9.175 10.8255C8.39167 10.0422 8 9.10049 8 8.00049C8 6.90049 8.39167 5.95882 9.175 5.17549C9.95833 4.39216 10.9 4.00049 12 4.00049C13.1 4.00049 14.0417 4.39216 14.825 5.17549C15.6083 5.95882 16 6.90049 16 8.00049C16 9.10049 15.6083 10.0422 14.825 10.8255C14.0417 11.6088 13.1 12.0005 12 12.0005ZM4 20.0005V17.2005C4 16.6338 4.146 16.1132 4.438 15.6385C4.73 15.1638 5.11733 14.8012 5.6 14.5505C6.63333 14.0338 7.68333 13.6465 8.75 13.3885C9.81667 13.1305 10.9 13.0012 12 13.0005C13.1 13.0005 14.1833 13.1298 15.25 13.3885C16.3167 13.6472 17.3667 14.0345 18.4 14.5505C18.8833 14.8005 19.271 15.1632 19.563 15.6385C19.855 16.1138 20.0007 16.6345 20 17.2005V20.0005H4Z",
    fill: "url(#paint0_linear_787_8471)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_787_8471",
    x1: 12,
    y1: 4.00049,
    x2: 12,
    y2: 20.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AA1EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientnew);
export default __webpack_public_path__ + "static/media/clientnew.25aa45dccac496d1fb50cb2a8164331e.svg";
export { ForwardRef as ReactComponent };